import React, {FC} from "react"

import GenericModal from "@irati/ui/src/GenericModal"
import {Body, H2} from "@irati/ui/src/Typography"
import FormattedMessage, {injectIntl} from "@irati/utils/lang"
import {InjectIntlProps} from "@irati/utils/lang/injectIntl"
import Flex from "@irati/ui/src/Flex"
import Button from "@irati/ui/src/Button"

interface Props extends InjectIntlProps {
  show: boolean
  btnText: string
  onHide: () => void
  onDownload: () => void
}

const IntegrationDisclaimerModal: FC<Props> = ({show, btnText, onHide, onDownload, formatMessage}) => {
  const handleOpenLink = () => {
    const url = formatMessage({id: "admin.components.updatePeopleCSV.integrationAlert.link"})
    window.open(url, "_blank")
  }

  const handleOnDownload = () => {
    onHide()
    onDownload()
  }

  return (
    <GenericModal show={show} onHide={onHide} hideActions>
      <Flex direction="column" alignItems="center">
        <H2 weight="light" marginBottom={3}>
          <FormattedMessage id="admin.components.updatePeopleCSV.integrationDisclaimer.title" />
        </H2>
        <img height="84px" width="84px" src={formatMessage({id: "admin.components.updatePeopleCSV.integrationDisclaimer.img"})} />
        <Body textAlign="center" marginTop={3}>
          <FormattedMessage id="admin.components.updatePeopleCSV.integrationDisclaimer.body" />
        </Body>
      </Flex>
      <Flex gap={2} marginTop={2} justifyContent="center" alignItems="center">
        <Button onClick={handleOnDownload} small primary>
          <FormattedMessage id={btnText} />
        </Button>
        <Button onClick={handleOpenLink} small>
          <FormattedMessage id="admin.components.updatePeopleCSV.integrationDisclaimer.buttonLink" />
        </Button>
      </Flex>
    </GenericModal>
  )
}

export default injectIntl(IntegrationDisclaimerModal)
